import { render, staticRenderFns } from "./edit-selected-place-button.vue?vue&type=template&id=6de2ae4d&scoped=true"
import script from "./edit-selected-place-button.vue?vue&type=script&lang=js"
export * from "./edit-selected-place-button.vue?vue&type=script&lang=js"
import style0 from "./edit-selected-place-button.vue?vue&type=style&index=0&id=6de2ae4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de2ae4d",
  null
  
)

export default component.exports